// src/pages/DeleteAccountPage.jsx
import React, { useState } from 'react';

const DeleteAccountPage = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [note, setNote] = useState('');
    const [response, setResponse] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !note) {
            setResponse('Email and Reason are required.');
            return;
        }

        setLoading(true);
        setResponse('');

        try {
            const res = await fetch('https://api.gamegems.co/web/users/account-delete', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ name, email, note })
            });

            const data = await res.json();
            if (res.ok) {
                setResponse('✅ Your account deletion request has been submitted.');
                setName('');
                setEmail('');
                setNote('');
            } else {
                setResponse(data?.message || '❌ Failed to submit request.');
            }
        } catch (error) {
            setResponse('❌ Something went wrong.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pt-10 pb-20 bg-black text-gray-400 min-h-screen">
            <div className="max-w-4xl mx-auto px-6">
                <h1 className="text-3xl font-bold mb-4 text-green">Delete your Game Gems app account</h1>
                <p>Use the form below to request deletion of your account created in the Game Gems app.</p>
                <div className="max-w-xl text-gray-400 rounded mt-10">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                User Name <small className="text-gray-500">(optional)</small>
                            </label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="w-full rounded p-3 bg-gray-900 text-white focus:outline-none"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Email Address <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full rounded p-3 bg-gray-900 text-white focus:outline-none"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Reason <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                required
                                rows={5}
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                className="w-full rounded p-3 bg-gray-900 text-white focus:outline-none"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-gradient text-white font-semibold py-3 px-4 rounded transition disabled:opacity-50"
                        >
                            {loading ? 'Submitting...' : 'Submit'}
                        </button>
                    </form>

                    {response && (
                        <div className="mt-4 p-3 rounded text-md bg-gray-900">
                            {response}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DeleteAccountPage;
